export const DEFAULT_LATE_FEE = 20;
export const LATE_FEE_DAYS = 15;
